import React, { useEffect, useState } from "react";

// Package Import
import {
  Typography,
  Box,
  useTheme,
  TextField,
  Button,
  Grid,
  Paper,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
  Input,
} from "@mui/material";
import { formControlClasses } from "@mui/material/FormControl";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { Add as AddIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";

// User Import

import { addvalidation } from "../../../../Services/validations/AdminPortal/Ministry";
import { headersPost } from "../../../../Services/API";
import { ADMIN_API_ULRS } from "../../../../Services/Routes/API";
import { RoutesUrls } from "../../../../Services/Routes/APP";
import { USER_ROLES_ENUM } from "../../../../common/Enums";
import { convertToFormData } from "../../../../common/functions";

//constants

const initialValue = {
  name: "",
  email: "",
  domain: "",
  population: "",
  logo: "",
};

// Component

const AddMinistry = () => {
  // Hooks

  const theme = useTheme();
  const navigate = useNavigate();

  //states

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [ministryLogoUrl, setMinistryLogoUrl] = useState("");

  // form submit handler

  const formSubmitHanlder = (values) => {
    const data = {
      ministry: {
        name: values?.name,
        email: values?.email,
        domain: values?.domain,
        population: values?.population,
        role: USER_ROLES_ENUM.ministry,
        quantity_dispatch: 0,
        logo: values?.logo,
      },
    };

    const formData = convertToFormData(data);

    setOpen(true);
    headersPost(ADMIN_API_ULRS.CREATE_MINISTRY, formData)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          navigate(-1);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //close alert

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
    setAlertMsg("");
    setAlertIcon("error");
  };

  // Render
  return (
    <Paper
      sx={{ p: 2, margin: "auto", maxWidth: 400, flexGrow: 1, borderRadius: 2 }}
    >
      <Box padding={2}>
        <Typography
          // display={"flex"}
          // justifyContent={"center"}
          width={"100%"}
          variant="h5"
          fontWeight={"bold"}
          display={"flex"}
          justifyContent={"center"}
          color={"text.grayText"}
          sx={{
            textTransform: "uppercase",
            paddingBottom: 2,
          }}
        >
          Add Ministry
        </Typography>
        <Formik
          initialValues={initialValue}
          onSubmit={formSubmitHanlder}
          validationSchema={addvalidation}
        >
          {({ values, touched, errors, handleChange, handleSubmit, setFieldValue, setFieldError, setFieldTouched }) => (
            <Form onSubmit={handleSubmit}>
              <Box padding={{ xs: 2, sm: 3, md: 5 }}>
                <Grid
                  container
                  justifyContent={"space-around"}
                  spacing={2}
                  margin={"auto"}
                  maxWidth={250}
                >
                 

                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      name="name"
                      onChange={handleChange}
                      error={touched?.name && Boolean(errors?.name)}
                      helperText={touched?.name && errors?.name}
                      value={values.name}
                      placeholder="Name"
                      fullWidth
                      sx={{
                        border: "1px solid grey",
                        [`& .${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(1),
                        },
                        [`&.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>

                
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      fullWidth
                      name="email"
                      type={"email"}
                      onChange={handleChange}
                      value={values.email}
                      error={touched?.email && Boolean(errors?.email)}
                      helperText={touched?.email && errors?.email}
                      placeholder="Email"
                      sx={{
                        border: "1px solid grey",
                        [`& .${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(1),
                        },
                        [`&.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>
               
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Population"
                      name="population"
                      type={"text"}
                      onChange={handleChange}
                      value={values.population}
                      error={touched?.population && Boolean(errors?.population)}
                      helperText={touched?.population && errors?.population}
                      fullWidth
                      sx={{
                        border: "1px solid grey",
                        [`& .${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(1),
                        },
                        [`&.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                  </Grid>
               
                  <Grid container>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Domain"
                      name="domain"
                      type={"text"}
                      onChange={handleChange}
                      value={values.domain}
                      error={touched?.domain && Boolean(errors?.domain)}
                      helperText={touched?.domain && errors?.domain}
                      fullWidth
                      sx={{
                        border: "1px solid grey",
                        [`& .${outlinedInputClasses?.root}`]: {
                          borderRadius: theme.spacing(1),
                        },
                        [`&.${formControlClasses?.root}`]: {
                          border: "none",
                        },
                      }}
                    />
                    <Grid
                      container

                      margin={"auto"}

                      marginTop={3}
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                    >
                      <Box>

                        <Button variant="contained" component="label">

                          Upload logo
                          <input
                            accept={"image/*"}
                            name={"logo"}
                            type={"file"}

                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file.size > 5 * 1024 * 1024) {
                                setAlertOpen(true);
                                setAlertMsg('File size is greater than 5MB!');
                                setAlertIcon("warning");
                                setFieldError('logo', 'File size is greater than 5MB!')
                                setFieldValue('logo', '');
                                setMinistryLogoUrl("")
                                e.target.value = ''
                              }
                              else {
                                setFieldValue('logo', file);
                                setMinistryLogoUrl(URL.createObjectURL(file))
                              }
                            }}
                            hidden
                          />
                        </Button>
                      </Box>

                      {(ministryLogoUrl && ministryLogoUrl !== "") ||
                      values?.logo?.url ? (
                        <Box
                          sx={{
                            margin: "auto",

                            marginTop: "1rem",
                            height: "8rem",
                            width: "8rem",
                            maxHeight: "8rem",
                            maxWidth: "8rem",
                          }}
                        >
                          <Box
                            component="img"
                            sx={{
                              height: "100%",
                              width: "100%",

                              borderRadius: "50%",

                            }}
                            alt="Ministry Logo"
                            src={ministryLogoUrl || values?.logo?.url}
                          />
                        </Box>
                      ) : null}
                    </Grid>
                    <Grid
                      container
                      marginTop={4}
                      display={"flex"}
                      justifyContent={"center"}
                    >
                      <Button
                        variant="contained"
                        type="submit"
                        size="large"
                        margin={"auto"}
                        sx={{
                          borderRadius: theme.spacing(1),
                          minWidth: "20%",
                        }}
                        startIcon={<AddIcon />}
                      >
                        {" "}
                        Add Ministry{" "}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleAlertClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default AddMinistry;
